import api from './api';

// 모델 API 함수들
const modelsApi = {
  // 임베딩 모델 목록 가져오기
  listEmbeddingModels: async () => {
    const response = await api.get('/models/embedding');
    return response.data;
  },
  
  // LLM 모델 목록 가져오기
  listLlmModels: async () => {
    const response = await api.get('/models/llm');
    return response.data;
  },
  
  // OpenAI LLM 모델 목록 가져오기
  listOpenAIModels: async () => {
    const response = await api.get('/models/llm/openai');
    return response.data;
  },
  
  // Ollama LLM 모델 목록 가져오기
  listOllamaModels: async () => {
    const response = await api.get('/models/llm/ollama');
    return response.data;
  },
  
  // OpenAI 임베딩 모델 목록 가져오기
  listOpenAIEmbeddingModels: async () => {
    const response = await api.get('/models/embedding/openai');
    return response.data;
  },
  
  // Sentence Transformers 임베딩 모델 목록 가져오기
  listSentenceTransformersEmbeddingModels: async () => {
    const response = await api.get('/models/embedding/sentence-transformers');
    return response.data;
  }
};

export default modelsApi; 